// CareLogix™ ORACLE — Animated Grant Discovery Feed (Phase 33 §7)
import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PALETTE } from "@/components/animation/MotionShared";
import { fundingApi } from "@/api/phase33Client";

export default function GrantDiscoveryFeed({ testid = "grant-discovery-feed" }) {
  const [opps, setOpps] = useState([]);
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    let cancelled = false;
    fundingApi.opportunities({ bucket: "all", limit: 24 })
      .then((r) => { if (!cancelled) setOpps(r.data?.opportunities || []); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);
  useEffect(() => {
    if (!opps.length) return undefined;
    const id = setInterval(() => setIdx((i) => (i + 1) % opps.length), 1700);
    return () => clearInterval(id);
  }, [opps.length]);
  if (!opps.length) return null;
  const items = [opps[idx], opps[(idx + 1) % opps.length], opps[(idx + 2) % opps.length]];
  return (
    <section style={S.shell} data-testid={testid} aria-label="Grant Discovery Feed">
      <header style={S.head}>
        <div style={S.eyebrow}>GRANT DISCOVERY FEED™ · LIVE</div>
        <h3 style={S.title}>{opps.length} open opportunities</h3>
      </header>
      <ul style={S.list}>
        <AnimatePresence>
          {items.map((o, i) => (
            <motion.li
              key={`${idx}-${o.opportunity_id}-${i}`}
              style={S.item}
              initial={{ opacity: 0, x: 16 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -16 }}
              transition={{ duration: 0.45 }}
              data-testid={`${testid}-item`}
            >
              <div>
                <div style={S.itemTitle}>{o.title}</div>
                <div style={S.itemMeta}>{o.source} · {o.region} · {o.days_to_deadline}d</div>
              </div>
              <span style={S.priority}>P{o.scores.priority_score}</span>
            </motion.li>
          ))}
        </AnimatePresence>
      </ul>
    </section>
  );
}

const S = {
  shell:   { background: "linear-gradient(180deg, rgba(8,32,22,0.55), rgba(4,6,8,0.85))", border: `1px solid ${PALETTE.goldGlow}`, borderRadius: 14, padding: 12, color: PALETTE.slate3, display: "flex", flexDirection: "column", gap: 8 },
  head:    { display: "flex", justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 8 },
  eyebrow: { color: PALETTE.gold, fontFamily: "'Space Mono', monospace", fontSize: 10, letterSpacing: "0.22em" },
  title:   { margin: 0, color: PALETTE.goldBright, fontSize: 13 },
  list:    { margin: 0, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 6 },
  item:    { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, padding: "8px 10px", background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.05)", borderRadius: 8 },
  itemTitle:{ color: PALETTE.slate3, fontSize: 12.5, fontWeight: 600 },
  itemMeta: { color: PALETTE.slate4, fontFamily: "'Space Mono', monospace", fontSize: 10, marginTop: 2 },
  priority: { color: PALETTE.gold, fontFamily: "'Space Mono', monospace", fontSize: 11, fontWeight: 800, padding: "3px 8px", border: `1px solid ${PALETTE.gold}`, borderRadius: 999 },
};
